import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../ui/TextField";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import RolesBadges from "../../OrgRequestView/RolesBadges";
import Chips from "../../../../../../../ui/Chips";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  typography: {
    color: "#778899"
  },
  closeButton: {
    position: "absolute",
    right: 4,
    top: 4,
    color: theme.palette.grey[500]
  },
  dialog: {
    width: "476px"
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 10
  },
  requestbody: {
    '& .MuiGrid-container':{
      marginBottom: 16
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  checkBoxLabel: {
    fontSize: 12
  },
  sendEmail: {
    height: 20,
    borderRadius: 10,
    color: "#FFF",
    background: "rgba(48, 73, 103, 0.8)",
    fontSize: 12,
    marginLeft: 8,
    paddingRight: 8,
    paddingLeft: 8,
    paddingTop: 2,
    display: "inline-block",
    justifyContent: "center",
    cursor: "default"
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography className={classes.typography}>{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, 0.12)"
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: "16px",
    "& > button:first-of-type": {
      marginRight: 4
    }
  }
}))(MuiDialogActions);



const AcceptRequestModal = ({
  requestData,
  requestInfo,
  open,
  handleClose,
  handleReload,
  handleAccept,
  classes,
  isAcceptingRequest,
  acceptedRequest
}) => {
  const [comment, setComment] = React.useState("");
  const [isSendEmail, setIsSendEmail] = React.useState(true);

  const onConfirm = () => {
    handleAccept(requestInfo.id, comment);
  };

  const onClose = () => {
    handleClose();
  };

  React.useEffect(() => {
    if (acceptedRequest && acceptedRequest.success) {
      setComment("");
      setIsSendEmail(false);
      handleClose();
    }
  }, [acceptedRequest]);

  //console.log(requestData);
  //console.log(requestInfo);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Подтверждение заявки</DialogTitle>
        <DialogContent>
          {requestData &&
          <div className={classes.requestbody}>
            <Typography className={classes.heading}>Проверьте сведения об организации</Typography>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Наименование
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {requestData.name ? requestData.name : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Регион
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {requestInfo.regionName ? requestInfo.regionName : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Муниципальное образование
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {requestData.municipalName ? requestData.municipalName : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Контактный телефон
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {requestData.phone ? requestData.phone : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  E-mail
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {requestData.email ? requestData.email : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  ОКВЭД
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {requestData.okved ? requestData.okved : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Сайт
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {requestData.site ? requestData.site : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Роли в системе
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  <RolesBadges
                    contractor={requestInfo.contractor}
                    customer={requestInfo.customer}
                    employer={requestInfo.employer}/>
                </Typography>
              </Grid>
            </Grid>

            <Typography className={classes.heading}>Представитель организации</Typography>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  ФИО
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {(requestData.lastName ? requestData.lastName : '') + ' ' +
                   (requestData.firstName ? requestData.firstName : '') + ' ' +
                   (requestData.middleName ? requestData.middleName : '')}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Должность
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {requestData.post ? requestData.post : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Логин
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {requestData.accountEmail ? requestData.accountEmail : '-'}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Учетная запись
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {requestData.createAccount ? 'создать' : 'не создавать'}
                </Typography>
              </Grid>
            </Grid>

            {requestInfo.contractor && <>
            <Typography className={classes.heading}>Дополнительно</Typography>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Виды услуг для ЦОПП
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="caption">
                  {(!requestData.offerDevelopment && !requestData.offerEducation && !requestData.offerResources) && '-'}

                  {(requestData.offerDevelopment) && <div>Разработка образовательных программ и цифровых учебных материалов;</div>}
                  {requestData.offerEducation && <div>Проведение обучения;</div>}
                  {requestData.offerResources && <div>Предоставление ресурсов;</div>}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Компетенции
                </Typography>
              </Grid>
              <Grid item xs={8}>
                {(requestData.worldSkills && requestData.worldSkills.length>0)
                  ? (<Chips largeWS={true} ellipsis={true} worldSkills={requestData.worldSkills}/>)
                  : (<Typography variant="caption">-</Typography>)}
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" color="textSecondary">
                  Профессии/Специальности
                </Typography>
              </Grid>
              <Grid item xs={8}>
                  {(requestData.specialities && requestData.specialities.length>0)
                    ? (<Chips ellipsis={true} specialities={requestData.specialities}/>)
                    : (<Typography variant="caption">-</Typography>)}
              </Grid>
            </Grid></>}

            <FormControlLabel
                control={
                  <Checkbox
                    onChange={(_, val) => setIsSendEmail(val)}
                    value="checked"
                    checked={isSendEmail}
                    color="primary"
                  />
                }
                label={
                  <span className={classes.checkBoxLabel}>
                    Отправить уведомление о подтверждении заявки на указанный email
                    <span className={classes.sendEmail}>{requestData.accountEmail}</span>
                  </span>
                }
                classes={{
                  label: classes.label,
                  root: classes.checkbox
                }}
            />
            {isSendEmail &&
            <TextField
              value={comment}
              onChange={e => setComment(e.target.value)}
              label="Сопроводительное сообщение"
            />}
          </div>
        }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isAcceptingRequest}
            disabled={isAcceptingRequest}
            onClick={() => onConfirm()}
            color="green"
          >
            Подтвердить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(AcceptRequestModal);
